import { Layer } from "../../types/layer";
import LayerControlItem from "./LayerControlItem";

interface FuelLoadControlProps {
  layer: Layer | null;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  onPanelOpenChange?: (open: boolean) => void;
}

const FuelLoadControl: React.FC<FuelLoadControlProps> = ({ layer, expanded, onExpandedChange, onPanelOpenChange }) => {
  if (!layer) return null;

  const handleToggleVisibility = () => {
    layer.toolbarButton?.props?.onClick?.();
  };

  return (
    <LayerControlItem
      title="Fuel Load"
      icon="scale"
      visible={layer.active ?? false}
      onToggleVisibility={handleToggleVisibility}
      enabled={layer.toolbarButton?.props?.enabled ?? true}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onPanelOpenChange={onPanelOpenChange}
    />
  );
};

export default FuelLoadControl;
